import React, { useEffect, useState } from "react";
import { Autocomplete, SvgIcon, TextField } from "@mui/material";
import {
  useRecoilCallback,
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import useCatchErrorApi from "src/shared/hooks/useCatchErrorApi";
import InputLabelCustom from "../../../shared/components/forms/InputLabelCustom";
import {
  daysAvailableState,
  filterSearchSelectedState,
  isChangeFormSearchState,
  activeTabState,
} from "../../state/atoms";
//import { activeTabState } from "src/SearchHours/state/atoms";
import { atencionFetchState, atencionState } from "./state/atoms";

import ManageStorage from "src/shared/global/manageStorage";

import { dayDefaultAvailableState } from "../calendars/state/atoms";

import "./GlobalCssAutocomplete.css";
import AtencionIcon from "../../../shared/icons/AtencionIcon";

import {  hoursAvailableState, professionalsMatchCovenantState, professionalsNoMatchCovenantState } from "src/SearchHours/state/atoms";
import { clinicasFetchState, clinicasState, covenantsState, examenState, professionalsState, serviciosState, specialitiesState, sucursalesState, tipoExamenState } from "src/SearchHours/components/autocompletes/state/atoms";
import ReactGA from "react-ga4";
const AutocompleteTipoConsulta = ({ size = "small", styles }) => {
  const { catchErrorApi } = useCatchErrorApi();
  const [loading, setLoading] = useState(false);
  const setIsChangeFormSearch = useSetRecoilState(isChangeFormSearchState);

  const atencion = useRecoilValue(atencionState);

  const [filterSearchSelected, setFilterSearchSelected] = useRecoilState(
    filterSearchSelectedState
  );

  //const [activeTabSearch, setActiveTabSearch] = useRecoilState(activeTabState);
  const setActiveTabSearch = useSetRecoilState(activeTabState);

  //   const resetDayDefaultAvailable = useResetRecoilState(
  //     dayDefaultAvailableState
  //   );
  //   const resetDaysAvailable = useResetRecoilState(daysAvailableState);

  //---
  const lugar = window.location.pathname.indexOf("buscar") >= 0;
  //---
  const resetProfessionalsMatchCovenant = useResetRecoilState(professionalsMatchCovenantState);
  const resetProfessionalsNoMatchCovenant = useResetRecoilState(professionalsNoMatchCovenantState);
  const resetFilterSearchSelected = useResetRecoilState(filterSearchSelectedState);
  const resetHoursAvailable = useResetRecoilState(hoursAvailableState);
  const resetDaysAvailable = useResetRecoilState(daysAvailableState);
  const setCovenants = useSetRecoilState(covenantsState);
  const setProfessionals = useSetRecoilState(professionalsState);
  const setSpecialities = useSetRecoilState(specialitiesState);
  const setTipoExamen = useSetRecoilState(tipoExamenState);
  const setExamen = useSetRecoilState(examenState);
  const setServicio = useSetRecoilState(serviciosState);

  const eventGA = (tipoAtencion = "") => {
    console.log("Evento Google Analytics -> Confirmar Hora Imagenologia");
    let clinica = filterSearchSelected.clinicaSelected.value;
    clinica = clinica != "" ? `Clinica: ${clinica}` : "";
    tipoAtencion = tipoAtencion != "" ? `| Tipo Atencion: ${tipoAtencion}` : "";
    console.log(`ga ${clinica} ${tipoAtencion}`);
    ReactGA.event({
      category: 'Buscar',
      action: `${clinica} ${tipoAtencion}`
    });
  }

  return (
    <>
      <InputLabelCustom
        htmlFor="autocomplete-atencion"
        text="Tipo Atención"
        style={{ ...styles.label }}
      />
      <Autocomplete
        style={{ ...styles.autocomplete }}
        size={size}
        id="autocomplete-atencion"
        options={atencion && atencion.map((option) => `${option.value}`)}
        getOptionLabel={(option) => option || null}
        value={filterSearchSelected.atencionSelected.value || null}
        noOptionsText="Sin resultados"
        onChange={(event, value, reason) => {
          console.log("SELECCIONAR ATENCION ==> ", reason);
          setIsChangeFormSearch(true);
          //resetDayDefaultAvailable();
          //resetDaysAvailable();
          console.log("code01", filterSearchSelected);
          
          resetProfessionalsMatchCovenant();
          resetProfessionalsNoMatchCovenant();
          resetFilterSearchSelected();
          resetHoursAvailable();
          resetDaysAvailable();

          if (reason === "clear") {
            setActiveTabSearch(-1);
            setFilterSearchSelected({
              ...filterSearchSelected,
              atencionSelected: {
                ...filterSearchSelected.atencionSelected,
                value: "",
                code: null,
              },
              clinicaSelected: {
                value: "",
                code: null,
              },
              sucursalSelected: {
                value: "",
                code: null,
              },
              specialitySelected: {
                value: "",
                code: null,
              },
              professionalSelected: {
                value: "",
                code: null,
              },
              covenantSelected: {
                value: "",
                code: null,
              },
            });

            return;
          }

          if (reason === "selectOption") {
            eventGA(value);
            //const findSpeciality = finderSpecialityByName(sucursales, value);
            setFilterSearchSelected({
              ...filterSearchSelected,
              atencionSelected: {
                ...filterSearchSelected.atencionSelected,
                value: value,
                code: value,
              },
              clinicaSelected: {
                value: "",
                code: null,
              },
              sucursalSelected: {
                value: "",
                code: null,
              },
              specialitySelected: {
                value: "",
                code: null,
              },
              professionalSelected: {
                value: "",
                code: null,
              },
            });

            console.log("Atencion => ", value);
            //ManageStorage.setItemStorage("clinica", value);

            if (value == "Consulta") {
              setActiveTabSearch(1);
            }
            if (value == "Imagenología") {
              setActiveTabSearch(2);
            }
            if (value == "Procedimiento") {
              setActiveTabSearch(3);
            }

            //loadSpecialities();
            ////window.location.reload(false);
          }
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              input: {
                "&::placeholder": {
                  ...styles.autocomplete,
                  opacity: 1,
                  fontWeight: 400,
                },
              },
            }}
            placeholder="Tipo de Atención"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                (lugar > 0 ) ?                 
                <>
                <SvgIcon sx={{fontSize: "15px"}}>
                  <AtencionIcon />
                </SvgIcon>
                  {params.InputProps.startAdornment}
                </>: null

              ),                 
            }}
          />
        )}
      />
    </>
  );
};

export default AutocompleteTipoConsulta;
